var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKitchen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.7,
    y: 41,
    width: 83.3,
    height: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.6,0H31.4c-2.1,0-3.8,1.7-3.8,3.8v41c0,2.1,1.7,3.8,3.8,3.8H48V41H35.1V7.5h156.7V41h-15.1v7.5h18.9 c2.1,0,3.8-1.7,3.8-3.8v-41C199.3,1.7,197.7,0,195.6,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M174.7,88.6h-18.2c-2.1,0-3.8-1.7-3.8-3.8V26c0-1.6,1-3,2.5-3.5c7.2-2.6,14.2-2.6,20.9,0c1.4,0.6,2.4,2,2.4,3.5v58.9 C178.4,86.9,176.7,88.6,174.7,88.6z M160.2,81.1h10.7V28.7c-3.5-0.9-7-0.9-10.7,0.1V81.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 161.8,
    y: 83.6,
    width: 7.5,
    height: 63.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.7,196.5C189.7,196.5,189.6,196.5,189.7,196.5H141c-1,0-2-0.4-2.7-1.1c-0.7-0.7-1.1-1.7-1.1-2.7l0.7-34.9 c0-0.2,0-0.4,0.1-0.5c1.5-8.9,9.7-15.4,19.5-15.4h15.6c9.8,0,18,6.5,19.5,15.4c0,0.2,0,0.4,0.1,0.5l0.7,34.1 c0.1,0.3,0.1,0.6,0.1,0.9C193.5,194.8,191.8,196.5,189.7,196.5z M144.8,189h41l-0.6-30.7c-1-5.1-6.1-8.8-12-8.8h-15.6 c-5.9,0-11.1,3.8-12,8.8L144.8,189z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 156.4,
    y: 160.8,
    width: 4.3,
    height: 18.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 160.8,
    width: 4.3,
    height: 18.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.8,88.7H50.6c-2.1,0-3.8-1.7-3.8-3.8V26.1c0-1.6,1-3,2.5-3.5c7.2-2.6,14.2-2.6,20.9,0c1.4,0.6,2.4,2,2.4,3.5V85 C72.5,87,70.9,88.7,68.8,88.7z M54.3,81.2H65V28.8c-3.5-0.9-7-0.9-10.7,0.1V81.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.7,200c-32.7,0-59.4-26.6-59.4-59.4s26.6-59.4,59.4-59.4c32.7,0,59.4,26.6,59.4,59.4S92.4,200,59.7,200z M59.7,88.7 c-28.6,0-51.9,23.3-51.9,51.9s23.3,51.9,51.9,51.9c28.6,0,51.9-23.3,51.9-51.9S88.3,88.7,59.7,88.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.7,179.4c-21.4,0-38.8-17.4-38.8-38.8s17.4-38.8,38.8-38.8c21.4,0,38.8,17.4,38.8,38.8S81.1,179.4,59.7,179.4z  M59.7,106.1c-19,0-34.5,15.5-34.5,34.5c0,19,15.5,34.5,34.5,34.5c19,0,34.5-15.5,34.5-34.5C94.2,121.6,78.7,106.1,59.7,106.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.f099d641d7114749371db170f8433665.svg";
export { ForwardRef as ReactComponent };